class RequestResetPasswordController extends AbstractController
	@register()
	@inject '$filter',
		'$state'
		'$stateParams'
		'PublicRepository'
		'ToastService'
		'parseBool'

	initialize: ->
		@isMasterUser = if @$stateParams.is_master_user? then @parseBool(@$stateParams.is_master_user) else true
		@identifier = null
		@email = null

	resetPassword: ->
		@loading = true

		@PublicRepository
			.requestResetPassword @email, @identifier
			.then =>
				@ToastService.add(
					@$filter('translate')('general.reset.email.sent').toString(),
					null,
					@$filter('translate')('general.reset.password'),
					'success'
				)

				if @isMasterUser
					@$state.go('login')
				else
					@$state.go('login.identifier', {identifier: @identifier})
			.catch (response) =>
				@handleErrors response, 'general.reset.password'
